module.exports = __webpack_public_path__ + "assets/img/exchange-btn.47be7ffc.png";